import RevelationIcon from "../assets/revelation.png";
import RepentanceIcon from "../assets/repentance.png";
import GraceIcon from "../assets/grace.png";
import LoveIcon from "../assets/love.png";
import FaithIcon from "../assets/faith.png";
import PurposeIcon from "../assets/purpose.png";
import FulfillmentIcon from "../assets/fulfillment.png";

import rayImage from "../assets/rays.webp";
import rainImage from "../assets/rain.webp";
import mistImage from "../assets/mist.webp";
import handsImage from "../assets/hands.webp";
import mountainsImage from "../assets/mountains.webp";
import roadImage from "../assets/road.webp";
import togetherImage from "../assets/together.webp";

export const themes = [
  {
    number: "01",
    title: "REVELATION",
    subtitle: "Awakening Light",
    reflection:
      "For me, it didn’t start with a big moment — it started with a song. My wife told me to give an album she’d been listening to a chance — King of Hearts by Brandon Lake. I put in my AirPods and away I went. God spoke so clearly through the words, awakening something deep inside me.",
    verse:
      "For God, who said, “Let light shine out of darkness,” made his light shine in our hearts to give us the light of the knowledge of God's glory displayed in the face of Christ.",
    reference: "2 Corinthians 4:6",
    accentColor: "#E63946",
    icon: RevelationIcon,
    image: rayImage,
  },
  {
    number: "02",
    title: "REPENTANCE",
    subtitle: "Turning Point",
    reflection:
      "There was a time I walked away from God. I thought faith had failed me, but really, I had closed my heart. I carried that stubbornness like a badge of pride. Yet even in my silence, God was patient. Every hard moment was still His plan, reminding me: if it’s not good, He’s not finished yet.",
    verse:
      "Repent, then, and turn to God, so that your sins may be wiped out, that times of refreshing may come from the Lord.",
    reference: "Acts 3:19",
    accentColor: "#F3722C",
    icon: RepentanceIcon,
    image: rainImage,
  },
  {
    number: "03",
    title: "GRACE",
    subtitle: "Undeserved Gift",
    reflection:
      "After all my sins and pride, God still met me with grace — not punishment, but blessing. He gave me this life and the opportunities that come with it, a wife whose love reflects His own, and a son who reminds me what purpose truly feels like. Grace didn’t just forgive me; it rebuilt me.",
    verse: "But where sin increased, grace increased all the more.",
    reference: "Romans 5:20",
    accentColor: "#FFD166",
    icon: GraceIcon,
    image: mistImage,
  },
  {
    number: "04",
    title: "LOVE",
    subtitle: "Unconditional Devotion",
    reflection:
      "Throughout my life, I’ve been surrounded by love — from family, friends, and strangers who didn’t owe me anything. Love that wasn’t always easy to give, yet was given anyway. Now I see that real love is selfless, a choice made even when it costs you something.",
    verse:
      "This is how we know what love is: Jesus Christ laid down his life for us. And we ought to lay down our lives for our brothers and sisters.",
    reference: "1 John 3:16",
    accentColor: "#06D6A0",
    icon: LoveIcon,
    image: handsImage,
  },
  {
    number: "05",
    title: "FAITH",
    subtitle: "Unseen Strength",
    reflection:
      "I’ve had seasons where my faith felt small — completely swayed and blinded by the enemy. But faith, to me, is surrendering my heart to God and letting Him reignite the fire within it. I can’t control every situation in my life, and neither should I. That’s when you pray for God’s help — and He steps in and says, “Watch this.”",
    verse:
      "If you have faith as small as a mustard seed, you can say to this mountain, ‘Move from here to there,’ and it will move.",
    reference: "Matthew 17:20",
    accentColor: "#118AB2",
    icon: FaithIcon,
    image: mountainsImage,
  },
  {
    number: "06",
    title: "PURPOSE",
    subtitle: "Divine Mission",
    reflection:
      "I’ve spent years wondering what my purpose was — chasing moments, missions, and callings I thought were somewhere ahead of me. But God’s been showing me it was here all along — in the people I love and the work I do every day. My purpose isn’t about what I achieve; it’s about who I serve while I do it.",
    verse:
      "‘For I know the plans I have for you,’ declares the Lord, ‘plans to prosper you and not to harm you, plans to give you hope and a future.’",
    reference: "Jeremiah 29:11",
    accentColor: "#5A2CA0",
    icon: PurposeIcon,
    image: roadImage,
  },
  {
    number: "07",
    title: "FULFILLMENT",
    subtitle: "Eternal Wholeness",
    reflection:
      "I used to think fulfillment meant finishing something — but now I know it means being used for something greater. God placed this vision on my heart, not to make my name known, but to make His known. Se7ens is just the beginning — a way to share my story, and if even one person draws closer to Him through this, that’s fulfillment to me.",
    verse:
      "He who began a good work in you will carry it on to completion until the day of Christ Jesus.",
    reference: "Philippians 1:6",
    accentColor: "#9C27B0",
    icon: FulfillmentIcon,
    image: togetherImage,
  },
];
